// extracted by mini-css-extract-plugin
export default {"canvas":"ParticleCanvas_canvas__TvjTE"};